<template>
  <button
    class="ui-icon-button"
    :class="[`ui-icon-button--${variant}`, `ui-icon-button--${size}`]"
    :type="type"
    :data-tone="tone ?? undefined"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: "primary" | "secondary" | "ghost";
    size?: "sm" | "md";
    type?: "button" | "submit" | "reset";
    tone?: "travel" | "work" | "combat" | "econ" | "social" | null;
  }>(),
  {
    variant: "ghost",
    size: "md",
    type: "button",
    tone: null
  }
);
</script>

<style scoped>
.ui-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: var(--radius-1);
  border: 1px solid transparent;
  transition: transform var(--dur-1) var(--ease-out), box-shadow var(--dur-1) var(--ease-out), border-color var(--dur-1) var(--ease-out);
}

.ui-icon-button--primary {
  background: color-mix(in srgb, var(--accent) 18%, transparent);
  border-color: color-mix(in srgb, var(--accent) 48%, transparent);
  color: var(--fg-0);
}

.ui-icon-button--secondary {
  background: var(--chip-muted-bg);
  border-color: var(--chip-muted-border);
  color: var(--fg-0);
}

.ui-icon-button--ghost {
  background: transparent;
  border-color: var(--surface-ghost-border);
  color: var(--fg-1);
}

.ui-icon-button--sm {
  width: 2rem;
  height: 2rem;
}

.ui-icon-button:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px color-mix(in srgb, var(--accent) 18%, transparent);
}

.ui-icon-button[data-tone="travel"] {
  --accent: var(--accent-travel);
}

.ui-icon-button[data-tone="work"] {
  --accent: var(--accent-work);
}

.ui-icon-button[data-tone="combat"] {
  --accent: var(--accent-combat);
}

.ui-icon-button[data-tone="econ"] {
  --accent: var(--accent-econ);
}

.ui-icon-button[data-tone="social"] {
  --accent: var(--accent-social);
}
</style>
